import { BaseOffer, BasePackageOffer } from './types';

const getTotal = (offer: BaseOffer) => {
  const amount = offer?.charges?.total?.amount;
  return Number(amount) ? Number(amount) : Infinity;
};

export const getRoomOffersSortedByCheapest = <Offer extends BaseOffer>(
  packageOffers: BasePackageOffer<Offer>[] | null | undefined,
) => {
  if (!packageOffers) {
    return undefined;
  }

  const roomOffers = packageOffers.flatMap((packageOffer) =>
    packageOffer.offers.map((offer) => ({
      ...offer,
      roomTypeId: packageOffer.roomTypeId,
    })),
  );

  return roomOffers.sort((a, b) => getTotal(a) - getTotal(b));
};
